import React from 'react';
import s from './LiveBarIcon.scss';

const LiveBarIcon = ({ text = 'LIVE' }) => (
  <span className={s.liveNowIcon}>{text}</span>
);

export default LiveBarIcon;
